module.exports = __webpack_public_path__ + "img/et.f306ee80.svg";